// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".mobile_centered.right-0[data-v-7e2fa07b]{right:-40%!important}.mobile_centered.left-0[data-v-7e2fa07b]{left:-40%!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
